import { gql } from "lib/apolloClient";
import { standardRubricFragment } from "AppComponents/StandardRubric/modules/StandardRubricFragments";
import {
  toolResponseFragment,
  userNameFragment,
} from "modules/CommonFragments";
import {
  aiTutorAwardEntryFragment,
  aiTutorAwardEntryReviewFragment,
  aiTutorListRowFragment,
} from "./AITutorAwardsFragments";

export const getAITutorAwardsListQuery = gql`
  query getAITutorAwardsList(
    $id: ID!
    $filters: AssessmentOrganizationFilters
    $first: Int
    $after: String
    $userArchivedFilters: UserArchivedFilters
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        assessments(first: $first, filters: $filters, after: $after) {
          totalCount
          edges {
            node {
              ...aiTutorListRow
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }
  ${aiTutorListRowFragment}
`;

export const getAITutorAwardsHasSubmittedQuery = gql`
  query getAITutorAwardsHasSubmitted($id: ID!) {
    node(id: $id, type: STAFF) {
      id
      ... on Staff {
        id
        aiTutorAwardEntries {
          id
        }
      }
    }
  }
`;

export const getAITutorAwardsSubmissionCountQuery = gql`
  query getAITutorAwardsSubmissionCount {
    globalConstants {
      aiTutorAwardSubmissionCount
    }
  }
`;

export const getAITutorAwardsSubmissionDetailsQuery = gql`
  query getAITutorAwardsSubmissionDetails($id: ID!) {
    node(id: $id, type: STAFF) {
      id
      ... on Staff {
        id
        aiTutorAwardEntries {
          ...aiTutorAwardEntryDetails
        }
      }
    }
  }
  ${aiTutorAwardEntryFragment}
`;

export const getAITutorAwardsNominationCandidatesQuery = gql`
  query getAITutorAwardsNominationCandidates(
    $organizationId: ID!
    $searchText: String
    $excludedStaffIds: [ID!]
    $first: Int
    $after: String
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        staff(
          first: $first
          after: $after
          filters: {
            roles: [teacher]
            archivalState: ACTIVE
            searchText: $searchText
            excludedStaffIds: $excludedStaffIds
          }
        ) {
          edges {
            node {
              ...userNameFields
              profileImage
              isArchived
              __typename
              ... on Staff {
                displayRole
                curriculumPrograms {
                  id
                  label
                  acronym
                }
              }
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }
  ${userNameFragment}
`;

export const getAITutorAwardsReviewQuery = gql`
  query getAITutorAwardsReview($id: ID!) {
    node(id: $id, type: ASSESSMENT) {
      id
      ... on Assessment {
        id
        assessmentTools {
          edges {
            node {
              id
              assessmentToolType
              isTeacherEvaluationEnable
              isStudentEvaluationEnable
              assessmentToolItem {
                id
                ... on StandardRubric {
                  ...standardRubricItem
                }
              }
            }
          }
        }
        aiConversation {
          edges {
            node {
              id
              entitySubType
            }
          }
        }
        ibPYPElementRatings {
          id
          ibPYPElementType
          value
          metadata
        }
        toolResponses: toolResponsesV2(filters: { userFilter: ALL }) {
          id
          toolId
          toolType
          toolResponses {
            ...toolResponseItem
          }
        }
        aiTutorAwardEntry {
          ...aiTutorAwardEntryReview
        }
      }
    }
  }
  ${aiTutorAwardEntryReviewFragment}
  ${standardRubricFragment.standardRubric}
  ${toolResponseFragment.toolResponse}
`;
